import { DateTime } from 'luxon'
import { DateNormalizer } from '../date_utils/normalizer'

export const stdDateParseFormat = 'yyyy-MM-dd';
export const stdDateDisplayFormat = 'MMM dd, yyyy';

/**
 * Parse a date string.
 *
 * @param {string} date - a date string: yyyy-MM-dd
 * @returns {DateTime} a Luxon DateTime object
 */
export function parseDate(date, format = "yyyy-MM-dd") {
  if (date === "") { return null }

  return DateTime.fromFormat(date, format)
}

export function isValidDate(date, format = "yyyy-MM-dd") {
  console.log(date);

  return parseDate(date, format).isValid
}

export function getLastImportedOn() {
  const meta = document.head.querySelector(`meta[name="importDate"]`)
  if (!meta?.content) { return DateTime.now() }

  const dt = DateTime.fromISO(meta.content)

  if (!dt.isValid) { return DateTime.now() }

  return dt
}

/**
 * Find the number of days between 2 dates
 * @param {Date, DateTime, String} minDate
 * @param {Date, DateTime, String} maxDate
 */
export function dayDiff(minDate, maxDate) {
  let dt1 = DateNormalizer.normalize(minDate)
  let dt2 = DateNormalizer.normalize(maxDate)

  return dt2.diff(dt1, 'days')
}

/**
 * Find the number of months between 2 dates
 * @param {Date, DateTime, String} minDate
 * @param {Date, DateTime, String} maxDate
 */
export function monthDiff(minDate, maxDate) {
  let dt1 = DateNormalizer.normalize(minDate)
  let dt2 = DateNormalizer.normalize(maxDate)

  return dt2.diff(dt1, 'months')
}
